/**
 * Lamination 1's extruder dashboard — the shared one, on `/lam1`.
 *
 * Replaces the old `ExtruderDashboard`, which read Line 1's extruders from
 * `kgreading` via `/blender/extruders*`. Those columns were fed by the
 * blender-1 PLC and went dead when Line 1's PLC was replaced; the signals now
 * come from the line's own PLC through lam1-worker.
 */
import React from "react";
import LamExtruderDashboard from "../../common/LamExtruderDashboard";
import { lam1Api } from "../../../api/lam1";

const Lam1ExtruderDashboard: React.FC = () => (
  <LamExtruderDashboard api={lam1Api} prefsKey="lam1" />
);

export default Lam1ExtruderDashboard;
